import React from "react";
import MarkReader from "../../components/global/MarkReader";
import Button from "../../components/global/Button";
import {
  useGetPolicyByIdQuery,
  useUpdatePolicyMutation,
} from "../../lib/redux/services/Api";
import { useParams } from "react-router-dom";
import { toastMessage } from "../../utils/utils";
import { toast } from "react-toastify";
import Loader from "../../components/skeletons/Loader";

const Policy = () => {
  const { id } = useParams();
  const { data, isFetching } = useGetPolicyByIdQuery(id);
  const [updatePolicy] = useUpdatePolicyMutation();
  //{id:id,type:"club",accept:false}

  const updatePolicyHandler = async () => {
    try {
      const data = await toast.promise(
        updatePolicy({ id: id, type: "club", accept: false }).unwrap(),
        toastMessage()
      );
    } catch (error) {
      console.error("Login error:", error);
    }
  };
  return (
    <div className="bg-white min-h-screen">
      {isFetching ? (
        <div className=" h-screen ">
          <Loader />
        </div>
      ) : (
        <div className="h-screen overflow-auto  ">
          <MarkReader file_name={data?.data[0]?.file_url} />

          <div className="fixed bottom-6  left-1/2 transform -translate-x-1/2 ">
            <Button
              customeStyle="bg-primaryRed text-white  text-lg rounded-lg px-5 py-2 hover:text-primaryRed hover:bg-white hover:border border-primaryRed transition duration-300   "
              width=" w-full "
              text={"Reject"}
              onClick={updatePolicyHandler}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Policy;
